// src/common/components/cartModal/components/yooKassaPaymentStage/hooks/useYooKassaPayment.ts

import { useEffect, useState, useCallback } from "react";
import { YooKassaStage } from "../../../types/enums";
import { useTheme } from "../../../hooks/useTheme";

// Объявляем тип для виджета (как в админке)
declare global {
  interface Window {
    YooMoneyCheckoutWidget?: any;
  }
}

interface UseYooKassaPaymentProps {
  onSuccess?: () => void;
  onError?: () => void;
}

export const useYooKassaPayment = (
  token: string,
  paymentId: string,
  { onSuccess, onError }: UseYooKassaPaymentProps = {},
) => {
  const [stage, setStage] = useState<YooKassaStage>(YooKassaStage.WIDGET);
  const [checkout, setCheckout] = useState<any>(null);
  const {theme} = useTheme()

  // Обработчики событий
  const handleSuccess = useCallback(async () => {
    setStage(YooKassaStage.SUCCESS);
    onSuccess?.();
  }, [onSuccess]);

  const handleFail = useCallback(() => {
    setStage(YooKassaStage.ERROR);
    onError?.();
  }, [onError]);

  // Инициализация виджета
  useEffect(() => {
    if (!token || token === "empty_token" || !window.YooMoneyCheckoutWidget) {
      return;
    }

    const widget = new window.YooMoneyCheckoutWidget({
      confirmation_token: token,
      customization: {
        modal: false,
        colors: {
          background: theme.card, // 👈 цвет карточки из темы
          // можно добавить и другие цвета
          text: theme.text,
          controlPrimary: theme.primary,
          controlPrimaryText: theme.onPrimary,
        },
      },
      error_callback: (error: any) => {
        console.error("YooKassa widget error:", error);
      },
    });

    // Подписываемся сразу после создания
    widget.on("success", handleSuccess);
    widget.on("fail", handleFail);

    setCheckout(widget);

    return () => {
      if (widget && widget.destroy) {
        // Отписываться не нужно — destroy сам всё почистит
        widget.destroy();
      }
    };
  }, [token, handleSuccess, handleFail]); // 👈 добавили зависимости

  // Рендер виджета
  useEffect(() => {
    if (!checkout || stage !== YooKassaStage.WIDGET) return;

    checkout
      .render("payment_form")
      .then(() => {
        // Виджет загружен
      })
      .catch((error: any) => {
        console.error("Failed to render widget:", error);
        setStage(YooKassaStage.ERROR);
        onError?.();
      });
  }, [checkout, stage, onError]);

  return { stage };
};
